export default "__VITE_ASSET__C$fin3CT__"